// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_spinner__spinner__e6dd0218","spin":"_spinner__spin__e6dd0218","isFixed":"_spinner__isFixed__e6dd0218","isAbsolute":"_spinner__isAbsolute__e6dd0218","isStatic":"_spinner__isStatic__e6dd0218"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/OverlaySpinner/_spinner.scss
// module id = 193
// module chunks = 4 5 7 8 9 10 16 20 22 39